import css from './CheckedQuestions.module.css';
import { SuccessWithBorderIcon } from '@shared/Icons/SuccessWithBorderIcon';
import { useMediaType } from '@shared/Hooks/useMediaTypeHook';

const CheckedQuestionsData: string[] = [
    'Want to build something?',
    "Don't know how much it will cost?",
    "Don't want to wait for someone to measure and prepare a BoM for you?",
];

export const CheckedQuestions: React.FC = () => {
    const [isDesktop, isTablet, isMobile] = useMediaType();
    return (
        <div className={css.container}>
            {CheckedQuestionsData.map((question, index) => (
                <div key={index} className={css.questionItem}>
                    <div className={css.icon}>
                        <SuccessWithBorderIcon
                            width={isDesktop ? 25 : 20}
                            height={isDesktop ? 25 : 20}
                            stroke={'var(--color-text-accent)'}
                            fill="white"
                            className={css.iconSvg}
                        />
                    </div>

                    <span>{question}</span>
                </div>
            ))}
        </div>
    );
};
